// extracted by mini-css-extract-plugin
export default {"metric-card":"MetricCard_metric-card__2K0d5"};